





import { Component, Prop, Vue } from 'vue-property-decorator';
import { DataType } from '@/core/data/DataType';
import apexchart from 'vue-apexcharts';
import { FView } from '@/core/FView';
import { VisitorsRecord } from '@/core/data/sets/VisitorsRecord';
import { Common } from '@/core/Common';
import moment from 'moment';
import { ApexExtensions } from '@/core/ApexExtensions';

@Component ({
  components: {
      apexchart
  },
})
export default class extends Vue {
    @Prop({ default: 350 }) height!: number;

    series = [{
        name: "Посещения",
        data: this.getYValues(),
    }];
    chartOptions = {
        chart: { },
        dataLabels: {
            enabled: false
        },
        stroke: {
            curve: 'smooth'
        },
        title: {
            text: 'Посещения по дням',
            align: 'center',
            style: {
                fontSize: '20px',
                fontFamily: 'FSElliotProBold',
            }
        },
        fill: {
            type: 'gradient',
            gradient: {
                enabled: true,
                shadeIntensity: 0,
                inverseColors: false,
                opacityFrom: 0.8,
                opacityTo: 0,
                stops: [0, 95, 100]
            },
        },
        grid: {
            row: {
                colors: ['#f3f3f3', 'transparent'],
                opacity: 0.5
            },
        },
        xaxis: {
            categories: this.getXValues(),
            labels: {
                hideOverlappingLabels: true,
                style: {
                    colors: this.getColors(),
                },
            },
            tooltip: {
                formatter: (val:string, opts:any) => {
                    let index = opts.dataPointIndex;
                    return this.getDetailedXValue(val, index);
                }
            },
        },
        markers: {
            style: 'inverted',
            size: 6
        },
        tooltip: {
            y: {
                title: {
                    formatter: (val:any) => {
                        return "Посещений";
                    }
                }
            }
        }
    };

    getDataSet(): VisitorsRecord[] {
        return FView.Get().dataManager.GetDataset<VisitorsRecord>(DataType.VisitorsDaily);
    }

    getYValues(): number[] {
        var dataSet = this.getDataSet();
        return dataSet.flatMap(d => d.visitors);
    }

    getXValues() {
        var dataSet = this.getDataSet();
        return dataSet.flatMap(d => Common.FormatDate(d.stat_date));
    }

    getColors() {
        var dataSet = this.getDataSet();
        return dataSet.flatMap(d => this.getColor(d.stat_date));
    }

    getColor(dt: string) {
        return Common.IsWeekend(dt) ? "#C11" : "#111"
    }

    getDetailedXValue(value:string, index: number) {
        let color = this.getColors()[index];
        let dow = moment(this.getDataSet()[index].stat_date).format('dddd');
        return `<label style="color: ${color}; font-size: 15px;">${value}<br>${dow}</label>`;
    }

    mounted() {
        new ApexExtensions(this.$el).FixOverlappingLabels();
    }
}
